import React from 'react'

function About() {
  return (
    <div name="about" className='w-full h-screen bg-gradient-to-b from-gray-800 to  black text-white'>
      
      <div className='max-w-screen-lg p-4 mx-auto flex-col justify-center
      w-full h-full'>
        <div className='pb-8'>
            <p className='text-4xl font-bold inline border-b-4 border-gray-500'>About</p>
        </div>
           <p className='text-xl mt-20'>
            Lorem ipsum dolor sit, amet consectetur adipisicing 
            elit. Autem, suscipit nesciunt quos quas delectus labore 
            asperiores perferendis, culpa a dicta, quo accusantium iste?
             Modi omnis dolorem nihil exercitationem rerum qui mollitia 
             nisi saepe laboriosam cum ipsa quidem est eaque, laudantium 
             quibusdam! Labore voluptas veniam illo iure repellendus 
             asperiores ullam dolor?
           </p>
           <br />

           <p className='text-xl'>
           Lorem ipsum dolor sit, amet consectetur adipisicing 
            elit. Autem, suscipit nesciunt quos quas delectus labore 
            asperiores perferendis, culpa a dicta, quo accusantium iste?
             Modi omnis dolorem nihil exercitationem rerum qui mollitia 
             nisi saepe laboriosam cum ipsa quidem est eaque, laudantium 
             quibusdam! Labore voluptas veniam illo iure repellendus 
             asperiores ullam dolor?
           </p>
      </div>
    </div>
  )
}

export default About
